import React, { Component } from "react";
import { learnerCountDisplay } from "../../../utils/learnerCount";
import { AxiosResponse, AxiosError } from "axios";
import { Api } from "../../../utils/Api";
import { CoursesResource } from "../../../stores/CoursesStore/Types";
import { Carousel } from "../../common";
import NewCourse from "./Courses/NewCourse";

interface Props {
  showHeading: boolean;
  userIsInUk: boolean;
}

interface State {
  featuredCourses: CoursesResource;
  loading: boolean;
}

class FeaturedCourses extends Component<Props, State> {
  static defaultProps = { showHeading: true };

  constructor(props) {
    super(props);

    this.state = {
      featuredCourses: [],
      loading: true,
    };
  }

  componentDidMount() {
    const client = new Api({});
    client
      .get<CoursesResource>("/api/featured_courses.json")
      .then((response: AxiosResponse<CoursesResource>) => {
        const { data } = response;
        this.setState({
          featuredCourses: data,
          loading: false,
        });
      })
      .catch((error: AxiosError) => {
        console.error(error.response?.statusText);
      });
  }

  render() {
    const { showHeading, userIsInUk } = this.props;

    const { featuredCourses, loading } = this.state;

    return (
      <div className="ui segment courses featured-courses">
        {loading && (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        )}

        <section className="courses-section">
          <div className="container">
            {showHeading && (
              <div className="header">
                <div>
                  <h2 className="section-title">Most Popular Courses</h2>
                  <p className="section-sub">
                    Chosen by {learnerCountDisplay()} learners. CPD-accredited. Certificate on
                    completion.
                  </p>
                </div>
              </div>
            )}
          </div>
          <div id="course-grid-popular-title">
            <div className="ui container" style={{ padding: "0" }}>
              <div className="course-grid">
                {featuredCourses.map((course, i) => (
                  <NewCourse
                    courseResource={course}
                    key={course.id}
                    userIsInUk={userIsInUk}
                    hideInMobile={i > 3}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="view-all-row">
            <a
              href="/courses"
              target="_blank"
              className="btn btn-blue"
              style={{ padding: "18px 48px", fontSize: "17px" }}
            >
              View All 40+ Courses →
            </a>
          </div>
        </section>
      </div>
    );
  }
}

export default FeaturedCourses;
